import {JsonObject, JsonProperty} from "json2typescript";

@JsonObject("ProfileUpdateInput")
export class ProfileUpdateInput {
    @JsonProperty("name", String)
    public name: string = "";

    @JsonProperty("email", String)
    public email: string = "";

    constructor(init?: Partial<ProfileUpdateInput>) {
        Object.assign(this, init);
    }
}
